module.exports = __webpack_public_path__ + "static/media/contractor-install.2b6b69ee.jpg";